import { Type } from '@hugendubel/ws_client';

export type OAuthValidationWebResult = Partial<{
    clientId: string;
    scope: string;
    displayName: string;
    redirectUri: string;
    responseType: string;
    error: string;
}>;

const parse = (json: any): OAuthValidationWebResult => ({
    clientId: Type.falsyToUndefined.string(json.clientId, 'OAuthValidationWebResult.clientId'),
    scope: Type.falsyToUndefined.string(json.scope, 'OAuthValidationWebResult.scope'),
    displayName: Type.falsyToUndefined.string(json.displayName, 'OAuthValidationWebResult.displayName'),
    redirectUri: Type.falsyToUndefined.string(json.redirectUri, 'OAuthValidationWebResult.redirectUri'),
    responseType: Type.falsyToUndefined.string(json.responseType, 'OAuthValidationWebResult.responseType'),
    error: Type.falsyToUndefined.string(json.error, 'OAuthValidationWebResult.error'),
});

export const WsOAuthValidationWebResult = { parse };
